<template>
  <div class="top-navbar w-full bg-white h-16 border-b border-gray-300 z-30">
    <div
      class="max-w-7xl h-full px-0 md:px-4 lg:px-4 xl:px-0 mx-auto flex flex-row justify-between items-center relative"
    >
      <div class="py-3 pl-2">
        <router-link
          to="/"
          @click="appService.pushToDataLayer('menu', 'logo', 'main', 'header')"
        >
          <img
            class="ml-2 h-8 w-auto"
            src="@/assets/images/iu-logo-horizontal.svg"
            alt="IU Logo"
          />
        </router-link>
      </div>

      <div
        class="md:px-0 flex flex-row items-center cursor-pointer whitespace-nowrap"
        @click="toggleNavMenu"
      >
        <div class="ml-4 flex flex-row-reverse md:flex-row items-center mr-4">
          <div class="ml-2 mb-1">
            <svg-icon name="bars" class="text-xl" />
          </div>
        </div>
      </div>
      <div
        class="fixed top-16 left-0 w-screen h-screen md:bg-transparent opacity-50 transition-opacity bg-black"
        :class="appStore.state.hideNavbar ? 'hidden' : 'block'"
        @click="toggleNavMenu"
      ></div>
      <transition name="slide-nav-right">
        <div
          class="top-nav-dropdown z-40 md:-mt-[5.5rem]"
          v-if="!appStore.state.hideNavbar"
          @mouseleave="mouseLeaveMenu"
        >
          <div class="hidden md:block w-full h-22"></div>
          <nav class="top-nav-dropdown-content pb-4 bg-white">
            <div v-if="!props.onlyLogout" class="pt-4 space-y-4">
              <div v-for="route in $router.options.routes" :key="route.name">
                <div v-if="route.meta?.unitRoute && route.children">
                  <div v-for="childRoute in route.children">
                    <hr
                      v-if="
                        childRoute.meta.topDivider &&
                        (!childRoute.meta.requiresStageMinimumReady ||
                          unitStore.stageMinimumReady())
                      "
                      class="mx-8 mt-6 mb-6 divide-gray-50"
                    />
                    <top-nav-button
                      v-if="
                        childRoute.meta.topNav &&
                        (!childRoute.meta.requiresStageMinimumReady ||
                          unitStore.stageMinimumReady())
                      "
                      :to="
                        childRoute.meta.redirect
                          ? childRoute.meta.redirect
                          : { name: childRoute.name }
                      "
                      :title="childRoute.meta.title"
                      class="mb-2"
                    >
                      <svg-icon
                        v-if="childRoute.meta.icon"
                        :name="childRoute.meta.icon"
                        class="text-lg mr-2"
                      />{{ childRoute.meta.title }}
                    </top-nav-button>
                  </div>
                </div>
              </div>
            </div>
            <hr class="mx-8 mb-4 divide-gray-50" />
            <div
              class="hover:bg-gray-200 px-8 py-3 flex items-center leading-5 text-black transition ease-in-out duration-150 text-sm cursor-pointer uppercase font-bold underline"
              @click="authStore.logoutUser()"
            >
              <svg-icon name="logout" class="text-lg mr-2"></svg-icon>
              {{ $t('general.logout') }}
            </div>
          </nav>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'
import TopNavButton from '@/components/TopNavButton.vue'
import appStore from '@/stores/app.store'
import authStore from '@/stores/auth.store'
import unitStore from '@/stores/unit.store'
import { computed } from 'vue'
import appService from '@/services/app.service'

interface Props {
  onlyLogout?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  onlyLogout: false,
})

const isMobile = computed(() =>
  ['xs', 'sm'].includes(appStore.state.screenSize),
)

const toggleNavMenu = () => {
  appStore.hideNavbar(!appStore.state.hideNavbar)
}
const mouseLeaveMenu = () => {
  if (isMobile.value) {
    return
  }
  appStore.hideNavbar(true)
}
</script>

<style scoped>
@reference '../../assets/styles/index.css';

.top-nav-dropdown {
  @apply bg-transparent w-72 transition-all;
  @apply fixed md:absolute right-0 md:right-0 top-16 md:top-16;
  @apply h-full md:h-auto;
}
.top-nav-dropdown-content {
  box-shadow:
    0 5px 5px -5px rgba(0 0 0 / 0.2),
    -5px 0 5px -5px rgba(0 0 0 / 0.2),
    5px 0 5px -5px rgba(0 0 0 / 0.2);
  @apply h-full md:h-auto;
}
</style>
